/* tslint:disable */
import {
  Product
} from '../index';

declare var Object: any;
export interface ClaimLineInterface {
  "id"?: number;
  "name"?: string;
  "product_returned_quantity"?: number;
  "product_id"?: number;
  "claim_descr"?: string;
  product?: Product;
}

export class ClaimLine implements ClaimLineInterface {
  "id": number;
  "name": string;
  "product_returned_quantity": number;
  "product_id": number;
  "claim_descr": string;
  product: Product;
  constructor(data?: ClaimLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ClaimLine`.
   */
  public static getModelName() {
    return "ClaimLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ClaimLine for dynamic purposes.
  **/
  public static factory(data: ClaimLineInterface): ClaimLine{
    return new ClaimLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ClaimLine',
      plural: 'ClaimLines',
      path: 'ClaimLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "product_returned_quantity": {
          name: 'product_returned_quantity',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "claim_descr": {
          name: 'claim_descr',
          type: 'string'
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ClaimLine.ts